import { createContext } from 'react';

export type BugReportContextType = {
  createBugReport: () => void;
};

const BugReportContext = createContext<BugReportContextType>({
  createBugReport: () => {},
});

export default BugReportContext;
